<fui-icon class="icon" *ngIf="icon" [icon]="icon.icon" [height]="icon.height || 20" [width]="icon.width || 20"
          [color]="icon.color" [clickable]="true" fui-touch (shortTouch)="selectOption()"></fui-icon>
<span class="option" fui-touch (shortTouch)="selectOption()">{{label(option)}}</span>
<fui-icon class="action" *ngIf="optionOpenable" [icon]="'chevron-right'" [height]="16" [width]="16"
          [clickable]="true" (click)="openOption($event)"></fui-icon>
